var _defs, _rect, _polygon, _polygon2, _path, _path2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _g, _line, _path3, _line2, _line3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituation4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_4",
    "data-name": "Calque 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3001.5 3001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-12,.cls-13,.cls-14,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-1{fill:url(#D\xE9grad\xE9_sans_nom_61);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_97);}.cls-3{fill:#6d503d;}.cls-4{fill:#f4f4f4;}.cls-5{fill:none;}.cls-6{fill:#757575;}.cls-7{fill:#c4c4c4;}.cls-8{fill:#d8d8d8;}.cls-9{fill:#b7b7b7;}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_18);}.cls-11{fill:#ddd;}.cls-12{fill:#e8e8e8;}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_13);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_18-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_61",
    x1: 1501,
    y1: 3000.5,
    x2: 1501,
    y2: 1165.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ededed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_97",
    x1: 1501,
    y1: 0.5,
    x2: 1501,
    y2: 2191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_18",
    x1: 889,
    y1: 1024,
    x2: 889,
    y2: 1745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    x1: 1221.65,
    y1: 1927.36,
    x2: 1036.34,
    y2: 1606.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_18-2",
    x1: 1311,
    y1: 959,
    x2: 1311,
    y2: 1630,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_18"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "situation 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1165.5,
    width: 3000,
    height: 1835
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1 2191.5 1888 1218.5 3001 1247.5 3001 0.5 1 0.5 1 2191.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1605.5 1716.55 2571.5 1799 2571.5 807 1618.5 829.39 1592.5 925 1592.5 1724 1605.5 1716.55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M581,438c-1-2-4-2-7-4-21-46-47-62-54-65s-37-11-59,11c-24.7,24.7-33,76-33,76V578a259.77,259.77,0,0,0-25,15c-41.24,28.48-58,58-64,74s1,44,22,44a22.54,22.54,0,0,0,19.52,11.35S492,745,494.26,718.27C494,689,492,668,484,663c-2-3,0-193,1-210s19-28,31-25,15,18,12,19-2,17,0,22,17,7,32,7,21-11,24-14S582,440,581,438ZM430.5,664.5l-16.35-4.27L431,640.07Z",
    transform: "translate(0.5 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M361.5,711.5c19-7,103-108.14,105-123,2.27-16.61-8-29-38-11",
    transform: "translate(0.5 0)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.5 736 697.5 711 1666.5 757 1666.5 797 690.5 775 0.5 797 0.5 736"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "0.5 736 518.5 754 530.5 797 466.5 797 530.5 2302 0.5 2504 0.5 736"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "530.5 2302 845.5 2400 1605.5 1780 1605.5 958 1618.5 958 1618.5 797 690.5 775 525.62 779.51 530 796.5 467 797.5 530.5 2302"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "684 775.5 525.69 779.78 530 796.5 467 797.5 530 2301.5 845 2399.5 697 1064.5 714 1062.5 684 775.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "697.5 1065 1046.5 1024 1080.5 1597 795.5 1745 697.5 1065"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "745.5 1078 706.5 1074 251.5 1174 364.5 2355 397.5 2375 827.5 2164 745.5 1078"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "745.5 1078 296.5 1181 251.5 1174 706.5 1074 745.5 1078"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "397.5 2375 296.5 1181 251.5 1174 364.5 2355 397.5 2375"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "296.5 1181 745.5 1078 827.5 2164 397.5 2375 296.5 1181"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "795.88 1745.23 1080.5 1597 1575.5 1630 827.5 2154.92 795.88 1745.23"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1046.5 1024 1080.5 1597 1575.5 1630 1562.5 959 1046.5 1024"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "m\\xE9canisme_\\xE9vie",
    "data-name": "m\\xE9canisme \\xE9vie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M935,1255c20,18,28,50,34,66s5,48,3,52a7.1,7.1,0,0,1-6,4l-3,49s-3,15-26,20-45,2-45,2-14-2-20-10-7-53-7-53l-4-2c-6-3-9-18-9-18H837l-1,2c-11,13-28,10-34,9s-6-10-6-10l-29.22.49L761,1290h36s0-5,16-8,23,3,23,3h25c1-7,10-15,10-15v-53c-10-3-20-24-20-24H828l-4,5c-12,15-24,16-38,14s-17-12-17-12l-14.76.37L750,1131h10s6-13,16-15c16-1,86-2,86-2v-3s-2,0-5-2c-3-5-4-17-4-17s-31,2-35,2-13-2-11-11c-43-2-41.44-26-41.44-26S927,1038,948,1035.51c1,16.51-17,32.49-17,32.49v6s7,0,10,6c1,31-8,31-8,31v70s9-3,10,8-8,22-8,22Z",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M797.5,1289.5c13.84,2,17,70-2,77",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M836,1285s8.5,6.5,8.5,39.5c0,20,0,25-7,41",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M852,1365s18,1,27-24-4-43-10-50-7-6-7-6",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M864.5,1384.5s6,9,30,5,40-20,63-17c7,1,9,5,9,5",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M870.5,1270.5s0,17,34,15,32-19,31-30",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M852.5,1193.5s73,4,80-11",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M861.5,1114.5s25.85-1.06,35,9c10,11,9.48,27.47,9,36-.62,10.88-8.49,25.1-20,29-12.21,4.14-33.86,6.92-34,5",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M760.5,1130.5s21-3,36,3,21,46,0,60-28,6-28,6",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M852.5,1092.5s-2-11,3-13,78,0,76-6",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M807.5,1083.5s27.88-8.34,14.44-33.17",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M848.78,1047s14.72,11.46,6.72,31.46",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 893,
    y1: 1114.4,
    x2: 892.32,
    y2: 1078.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M929.15,1075.35s8.35,1.15,3.35,35.15a160.81,160.81,0,0,1-71,0",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M867.22,1078.63c-3.07,0-6.42,23.22,0,33",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 895,
    y1: 1218.77,
    x2: 895,
    y2: 1193.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M928.36,1186.57q8.28,13.92,0,27.85",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M867.5,1193.5c-3.71,4.52-3.09,13.63,3,24a248.35,248.35,0,0,0,36,1c18-1,29-7,29-7",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M807.5,1147.62q10.44-10.42,20.88-6.95",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M779,1129.75c.36-7,3.16-12.13,9.8-14.42",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M802.29,1188.24c7.48,6.65,15.62,7.77,24.21,5.26,0,0,7-12,7-31s-14.43-48.28-40.71-47.14",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M783.91,1200.5c1.84,7.44,5.72,12,12.78,12.25",
    transform: "translate(0.5 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 845,
    y1: 1324.5,
    x2: 882.58,
    y2: 1325.25
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 467,
    y1: 797.5,
    x2: 0.5,
    y2: 792.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M476.55,718.91c.88-37.52-17.35-52.95-46.05-54.41,16.24,20.6,16.67,39.29-.7,56.08",
    transform: "translate(0.5 0)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 431.35,
    y1: 647.77,
    x2: 483.81,
    y2: 647.77
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 483.67,
    y1: 630.86,
    x2: 438.16,
    y2: 631.77
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.5,446.5c23.78,2.67,40-.93,46-13",
    transform: "translate(0.5 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituation4);
export default __webpack_public_path__ + "static/media/situation_4.7efacdb765fecaa21e9562f2295c8632.svg";
export { ForwardRef as ReactComponent };